import axios from "axios";
import { Store } from "vuex";
import VueRouter from "vue-router";
import TranslationService from "@/shared/services/translation.service";
import { IUserUI } from "@/shared/model/user-management/userUI.model";
import ParameterService from "@/shared/services/user-management/parameter.service";
export default class AccountService {
  constructor(
    private store: Store<any>,
    private translationService: TranslationService,
    private parameterService: ParameterService,
    private router: VueRouter
  ) {
    this.init();
  }

  public init(): void {
    this.retrieveProfiles();
  }

  public retrieveProfiles(): void {
    axios.get("management/info").then((res) => {
      if (res.data && res.data.activeProfiles) {
        this.store.commit("setRibbonOnProfiles", res.data["display-ribbon-on-profiles"]);
        this.store.commit("setActiveProfiles", res.data["activeProfiles"]);
      }
    });
  }

  public retrieveAccount(): Promise<any> {
    return new Promise<boolean>(async (resolve, reject) => {
      try {
        let response = await axios.get("api/account");
        this.store.commit("authenticate");
        const account = response.data; // de type java BasicUserInfoVM
        if (account) {
          this.store.commit("authenticated", account);
          /* original code*/
          if (sessionStorage.getItem("requested-url")) {
            console.log("requested-url: " + sessionStorage.getItem("requested-url"));
            this.router.replace(sessionStorage.getItem("requested-url"));
            sessionStorage.removeItem("requested-url");
          }

          //get parameters
          let listParametersActivated = await this.parameterService.getListParametersActivated();
          this.store.commit("listParametersActivated", listParametersActivated);
        } else {
          this.store.commit("logout");
          this.router.push("/");
          sessionStorage.removeItem("requested-url");
        }
        if(this.store.getters.account){
          if(this.store.getters.account.langKey === 'fr-CA'){
            localStorage.setItem('currentLanguage', this.store.getters.account.langKey);
            this.translationService.refreshTranslation(this.store.getters.account.langKey);
          }else{
            this.translationService.refreshTranslation('fr');
          }
        }
        
        

        // Get user data
        var user: IUserUI = await this.getMyUser();
        this.store.commit("setUser", user); // update vuex
        this.store.commit("setOffer", user.offer);

        resolve(true);
      } catch (error) {
        console.error(error);
        this.store.commit("logout");
        this.router.push("/");
        // Remove expired or wrong JWT Token
        if (sessionStorage.getItem("jhi-authenticationToken")) sessionStorage.removeItem("jhi-authenticationToken");
        if (localStorage.getItem("jhi-authenticationToken")) {
          localStorage.removeItem("jhi-authenticationToken");
        }
        reject(false);
      }
    });
  }

  public async hasAnyAuthorityAndCheckAuth(authorities: any): Promise<boolean> {
    if (typeof authorities === "string") {
      authorities = [authorities];
    }

    if (!this.authenticated || !this.userAuthorities) {
      const token =
        localStorage.getItem("jhi-authenticationToken") || sessionStorage.getItem("jhi-authenticationToken");
      if (!this.store.getters.account && !this.store.getters.logon && token) {
        console.log("Get login from bearer");
        await this.retrieveAccount();
      } else {
        // if no token
        return new Promise((resolve) => {
          resolve(false);
        });
      }
    }

    // if has authorities to visit a page return true
    for (let i = 0; i < authorities.length; i++) {
      if (this.userAuthorities.includes(authorities[i])) {
        return new Promise((resolve) => {
          resolve(true);
        });
      }
    }

    return new Promise((resolve) => {
      resolve(false);
    });
  }

  public get authenticated(): boolean {
    return this.store.getters.authenticated;
  }

  public get userAuthorities(): any {
    return this.store.getters.account.authorities;
  }

  public getMyUser(): Promise<IUserUI> {
    return new Promise<IUserUI>((resolve, reject) => {
      axios
        .get("api/global/get-my-user")
        .then(function (res) {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public authenticate(data): Promise<any> {
    return new Promise<IUserUI>((resolve, reject) => {
      axios
        .post("api/authenticate", data)
        .then(function (res) {
          const bearerToken = res.headers.authorization;
          if (bearerToken && bearerToken.slice(0, 7) === "Bearer ") {
            const jwt = bearerToken.slice(7, bearerToken.length);
            if (data.rememberMe) {
              localStorage.setItem("jhi-authenticationToken", jwt);
            } else {
              sessionStorage.setItem("jhi-authenticationToken", jwt);
            }
          }
          resolve(res.data);
        })
        .catch((err) => {
          console.error(err);
          reject(err);
        });
    });
  }

  public authenticateWithLinkedIn(code): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .post("api/authenticate/linked-in", code)
        .then(function (res) {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
}
